module.exports = __webpack_public_path__ + "static/DrumKitOptimized-fdfc7516a38d90421d3e41254dd55308.gif";